import ImageModal from "@components/features/image-modal/ImageModal";
import { PRODUCT_NOT_FOUND_IMG } from "@const/products.const";
import { ProductImage } from "@interfaces/components/product-image.interface";
import { useWindowDimensions } from "@utils/common.util";
import React, { useState, useEffect, useRef } from "react";
import Slider from "react-slick";

interface Props {
  productImages: ProductImage[];
}

const SliderSync = ({ productImages }: Props) => {
  const [nav1, setNav1] = useState<Slider>();
  const [nav2, setNav2] = useState<Slider>();
  let sliderRef1: any = useRef<Slider>(null);
  let sliderRef2: any = useRef<Slider>(null);

  const [oldSlide, setOldSlide] = useState(0);
  const [activeSlide, setActiveSlide] = useState(0);
  const [activeSlide2, setActiveSlide2] = useState(0);

  useEffect(() => {
    setNav1(sliderRef1);
    setNav2(sliderRef2);
  }, []);

  //  modal when onclick selected image
  const [selectedProductImg, setSelectedProductImg] = useState<null | string>(
    null
  );
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  // let sizeScreen = useWindowDimensions().width;
  const showImageModal = () => {
    if (selectedProductImg === null) {
      return;
    }
    return (
      <>
        <ImageModal
          // screenSize={sizeScreen}
          isShow={show}
          handleClose={handleClose}
          selectedImg={selectedProductImg}
        />
      </>
    );
  };
  return (
    <>
      {/* Modal */}
      {showImageModal()}

      {productImages && productImages.length > 0 ? (
        <>
          {/* Slider */}
          <div className="slider-container">
            <div className="position-relative">
              {/* Main Slider */}
              <Slider
                asNavFor={nav2}
                ref={(slider) => (sliderRef1 = slider)}
                arrows={false}
                responsive={[
                  {
                    breakpoint: 991,
                    settings: {
                      focusOnSelect: true,
                      infinite: true,
                      slidesToShow: 1,
                      speed: 500,
                      beforeChange: (current, next) => {
                        setOldSlide(current);
                        setActiveSlide(next);
                      },
                      afterChange: (current) => setActiveSlide2(current),
                    },
                  },
                ]}
              >
                {productImages.map(
                  ({ url, alt, type, video_url, video_title }, idx) => (
                    <div key={idx}>
                      {type === "external-video" ? (
                        <div className="py-4">
                          <iframe
                            width="100%"
                            height="400px"
                            src={video_url}
                            title={video_title}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                          ></iframe>
                        </div>
                      ) : (
                        <img
                          key={idx}
                          src={url}
                          alt={alt}
                          className="img-fluid"
                          onClick={() => {
                            setSelectedProductImg(url);
                            setShow(true);
                          }}
                        />
                      )}
                    </div>
                  )
                )}
              </Slider>
              <p className="text-end position-absolute bottom-0 end-0 me-3 d-block d-lg-none">
                <span className="badge rounded-pill text-bg-light">
                  {activeSlide2 + 1} / {productImages.length}
                </span>
              </p>
            </div>

            {/* Thumbnails Slider */}
            {productImages && productImages.length > 0 && (
              <div className="img-thumb d-none d-lg-block mt-2">
                <Slider
                  asNavFor={nav1}
                  ref={(slider) => (sliderRef2 = slider)}
                  slidesToShow={
                    productImages.length > 2 ? 3 : productImages.length
                  }
                  swipeToSlide={true}
                  focusOnSelect={true}
                  centerMode={true}
                  centerPadding={
                    productImages.length > 2
                      ? "60px"
                      : productImages.length === 1
                      ? "170px"
                      : "120px"
                  }
                  infinite={true}
                  responsive={[
                    {
                      breakpoint: 480,
                      settings: {},
                    },
                  ]}
                >
                  {productImages.map(({ url, alt }, idx) => (
                    <div key={idx} className="slick-item">
                      <img src={url} alt={alt} className="img-fluid" />
                    </div>
                  ))}
                </Slider>
              </div>
            )}
          </div>
        </>
      ) : (
        <img src={PRODUCT_NOT_FOUND_IMG} className="img-fluid" alt="No image" />
      )}
    </>
  );
};

export default SliderSync;
